/**
 * ADA Fix: Manage Focus & ARIA Live Announcements for Boost Pagination
 * Resolves WCAG 2.4.3 (Focus Order) and WCAG 4.1.2 (Name, Role, Value)
 */

// This goes inside the 'Success' callback of your Add to Cart fetch
const statusRegion = document.getElementById('accessible-status-region');
if (statusRegion) {
  statusRegion.textContent = 'Item successfully added to your cart.';
}

(function() {
    let isPaginationClicked = false;
    let announcementText = "New products loaded."; // Default fallback text

    // 1. Create a visually hidden ARIA live region for screen reader announcements
    const createLiveRegion = () => {
        let liveRegion = document.getElementById('boost-ada-announcer');
        if (!liveRegion) {
            liveRegion = document.createElement('div');
            liveRegion.id = 'boost-ada-announcer';
            liveRegion.setAttribute('aria-live', 'polite');
            liveRegion.setAttribute('aria-atomic', 'true');
            
            // Standard CSS to visually hide the element while keeping it accessible
            Object.assign(liveRegion.style, {
                position: 'absolute',
                width: '1px',
                height: '1px',
                padding: '0',
                margin: '-1px',
                overflow: 'hidden',
                clip: 'rect(0, 0, 0, 0)',
                whiteSpace: 'nowrap',
                border: '0'
            });
            document.body.appendChild(liveRegion);
        }
        return liveRegion;
    };

    const liveRegion = createLiveRegion();

    // 2. Intercept clicks to determine if the user interacted with pagination
    document.addEventListener('click', function(event) {
        // Target the specific button clicked within the pagination container
        const paginationButton = event.target.closest('button.boost-sd__pagination-number, a.boost-sd__pagination-number, .boost-sd__pagination-button');
        const paginationContainer = event.target.closest('.boost-sd__pagination');
        
        if (paginationContainer && paginationButton) {
            isPaginationClicked = true;
            
            // Attempt to grab the page number (e.g., "2", "3") for a better announcement
            const pageText = paginationButton.textContent.trim();
            if (pageText && !isNaN(pageText)) {
                announcementText = `Page ${pageText} loaded.`;
            } else {
                // Fallback for "Next" or "Load More" buttons
                announcementText = "New page of products loaded.";
            }
        } else if (event.target.closest('.boost-sd__filter-block')) {
            // Do not hijack focus/announcements if they are just clicking filters
            isPaginationClicked = false;
        }
    }, true);

    // 3. Observe the product grid for DOM updates
    const initializeADAObserver = function() {
        const gridContainer = document.querySelector('.boost-sd__product-list');
        
        if (!gridContainer) {
            setTimeout(initializeADAObserver, 500);
            return;
        }

        const observer = new MutationObserver(function(mutations) {
            if (isPaginationClicked) {
                const hasNewNodes = mutations.some(mutation => mutation.addedNodes.length > 0);
                
                if (hasNewNodes) {
                    setTimeout(() => {
                        // A. Trigger the screen reader announcement
                        // Briefly clearing the text ensures the screen reader registers it as a "change" even if clicking the same button
                        liveRegion.textContent = ''; 
                        setTimeout(() => { liveRegion.textContent = announcementText; }, 50);

                        // B. Manage keyboard focus
                        const firstProduct = gridContainer.querySelector('.boost-sd__product-item');
                        if (firstProduct) {
                            firstProduct.setAttribute('tabindex', '-1');
                            firstProduct.focus();
                            firstProduct.style.outline = 'none'; 
                        }
                        
                        // C. Reset the flag
                        isPaginationClicked = false; 
                    }, 100); 
                }
            }
        });

        observer.observe(gridContainer, { childList: true, subtree: false });
    };

    // 4. Start the observer
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initializeADAObserver);
    } else {
        initializeADAObserver();
    }
})();